import type { WidgetConfig } from '../../types';
import { WeeklyCalendarLayout } from './weekly-calendar';

export type LayoutRenderer = (container: HTMLElement, config: WidgetConfig) => any;

/**
 * Layout registry - maps layout names to renderer classes
 */
const LAYOUT_REGISTRY: Record<string, new (container: HTMLElement, config: WidgetConfig) => any> = {
  'weekly-calendar': WeeklyCalendarLayout,
  // Future layouts can be added here:
  // 'list': ListLayout,
  // 'compact': CompactLayout,
  // etc.
};

/**
 * Gets a layout renderer instance for the given layout name
 */
export function getLayoutRenderer(
  layout: WidgetConfig['layout'],
  container: HTMLElement,
  config: WidgetConfig
): any {
  const LayoutClass = LAYOUT_REGISTRY[layout] || LAYOUT_REGISTRY['weekly-calendar'];
  return new LayoutClass(container, config);
}
